export default {"src":"/_next/static/media/FOX.cada1957.svg","height":18,"width":18};